import { Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable, from } from 'rxjs';
import { DataService } from 'src/app/services/data/data.service';
import { FetchSocialDefaults, setStateUpdateDate } from 'src/app/store/social.state';

@Injectable({
  providedIn: 'root'
})
export class SocialResolver implements Resolve<boolean> {

  constructor(
    private store: Store,
    private dataService: DataService
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return from(this.setupSocial());
  }

  private async setupSocial() {
    let StateLoadDate = this.store.selectSnapshot<Date>(store => store.SocialState.StateLoadDate);
    const currentDate = new Date;
    if (StateLoadDate != null) {
      const diffMs = (currentDate.getTime() - StateLoadDate.getTime());
      if (Math.round(diffMs / 60000) < 5) {
        return true;
      }
    }
    try {
      // await this.store.dispatch(new FetchSocialDefaults).toPromise();
      // await this.store.dispatch(new setStateUpdateDate(new Date)).toPromise();
      await this.dataService.loadSocialState();
      return true;
    } catch (error) {
      console.log(error);
      return false;
    }
  }
}
